import React from 'react';
const ChevronArrow = (props) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M12.456 5.26a.874.874 0 0 1 1.304.067c.316.378.317.945.019 1.323l-.081.09-5.077 5a.87.87 0 0 1-1.15.08l-.092-.08-5.077-5a1.06 1.06 0 0 1-.062-1.413.873.873 0 0 1 1.213-.146l.091.08 4.455 4.388 4.457-4.389z'
        fill='var(--theme-primary, #810ea9)'
        fillRule='nonzero'
      />
    </svg>
  );
};

export default ChevronArrow;
